export default class LocalisationMarker {
	static init() {
		this.DOM = {};
		this.DOM.els = [...document.querySelectorAll('.text-localisation')];
		this.markerIcon = `
			<svg width="21" height="27" viewBox="0 0 21 27" xmlns="http://www.w3.org/2000/svg">
				<path d="M10.2998 26C10.6006 26 10.881 25.8682 11.0703 25.635C11.9421 24.5706 19.5996 15.1018 19.5996 10.2998C19.5996 5.17343 15.4296 1 10.2998 1C5.17005 1 1 5.17005 1 10.2998C1 15.1018 8.6541 24.5706 9.52933 25.635C9.71857 25.8648 9.99905 26 10.2998 26ZM10.2998 2.3551C14.6828 2.3551 18.2479 5.92025 18.2479 10.3032C18.2479 13.7197 13.2026 20.85 10.2998 24.4421C7.40038 20.85 2.35172 13.7197 2.35172 10.3032C2.35172 5.92025 5.91687 2.3551 10.2998 2.3551Z" />
				<path d="M14.9975 10.1245C14.9975 7.53254 12.8888 5.42725 10.3002 5.42725C7.71171 5.42725 5.60303 7.53592 5.60303 10.1245C5.60303 12.713 7.71171 14.8217 10.3002 14.8217C12.8888 14.8217 14.9975 12.713 14.9975 10.1245ZM6.95136 10.1245C6.95136 8.27937 8.45177 6.77896 10.2969 6.77896C12.142 6.77896 13.6424 8.27937 13.6424 10.1245C13.6424 11.9696 12.142 13.47 10.2969 13.47C8.45177 13.47 6.95136 11.9696 6.95136 10.1245Z" />
			</svg>
		`;

		if (this.DOM.els.length === 0) {
			return;
		}

		this.DOM.els.forEach((el) => {
			el.innerHTML = `<span>${el.innerHTML}</span>`;

			const svgContainer = document.createElement('i');
			svgContainer.setAttribute('aria-hidden', 'true');
			svgContainer.setAttribute('class', 'svg');
			svgContainer.innerHTML = this.markerIcon;

			el.appendChild(svgContainer);
		});
	}
}